import { Pencil, Eye } from "lucide-react";
import { Switch } from "@/components/ui/switch";

/**
 * Persistent top banner shown to a logged-in Master Admin on every public
 * page (regardless of whether `?edit=yes` is set) — lets them flip Edit
 * Mode on/off from wherever they're browsing, not just from the link in
 * the admin dashboard. `data-slh-top-banner` nudges the sticky header CTA
 * below it automatically (see useStickyTopOffset).
 */
export default function EditModeBanner({ isAdmin, editMode, onToggle, dialogOpen = false }) {
  if (!isAdmin) return null;

  return (
    <div
      data-slh-top-banner
      data-testid="edit-mode-banner"
      className={`sticky top-0 z-[60] flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium transition-colors ${
        editMode ? "bg-amber-500 text-white" : "bg-slate-800 text-white"
      } ${dialogOpen ? "pointer-events-none opacity-60" : ""}`}
    >
      {editMode ? (
        <>
          <Pencil className="h-4 w-4" />
          <span>Edit Mode is ON — hover any section and click to edit it</span>
        </>
      ) : (
        <>
          <Eye className="h-4 w-4" />
          <span>Viewing as Master Admin</span>
        </>
      )}
      <label className="flex items-center gap-2 ml-2 cursor-pointer select-none" data-testid="edit-mode-toggle-label">
        <span className="text-xs opacity-90">Edit Mode</span>
        <Switch
          checked={editMode}
          onCheckedChange={onToggle}
          data-testid="edit-mode-toggle-switch"
        />
      </label>
    </div>
  );
}
